import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';

class Container extends Component {
  render() {
    return (
      <div id="keywords">
        <Route exact path="/keywords" component={List} />
      </div>
    );
  }
}

export default Container;
